import type { InternalAxiosRequestConfig } from "axios";
import { useConfig } from "../../../packages/config";
import { getSafeConfigValue } from "../../../packages/config/safe-config";
import type { SafeConfig } from "../../../packages/config/safe-config/index.types";
import type { EOSEndpoint } from "../index.enum";
import { isEOSRequestConfig } from "../index.types";

const EOS_ENDPOINT_DICTIONARY = {
	GENERIC: "REACT_APP_EOS_ENDPOINT",
	VEHICLE_MANAGEMENT: "REACT_APP_EOS_V2_VEHICLE_MANAGEMENT_ENDPOINT",
	VEHICLE_HEALTH: "REACT_APP_EOS_V2_VEHICLE_HEALTH_ENDPOINT",
	VEHICLE_MAINTENANCE: "REACT_APP_EOS_V2_VEHICLE_MAINTENANCE_ENDPOINT",
	SERVICE_MANAGEMENT: "REACT_APP_EOS_V2_SERVICE_MANAGEMENT_ENDPOINT",
	VEHICLE_INFO: "REACT_APP_EOS_V2_VEHICLE_INFO_ENDPOINT",
	VEHICLE_SUBSCRIPTION: "REACT_APP_EOS_V2_VEHICLE_SUBSCRIPTION_ENDPOINT",
} as const satisfies Record<EOSEndpoint, keyof SafeConfig>;

const useServiceInterceptor = () => {
	const config = useConfig();
	return async (internalConfig: InternalAxiosRequestConfig) => {
		try {
			if (!isEOSRequestConfig(internalConfig)) return internalConfig;
			if (!internalConfig.service) return internalConfig;
			internalConfig.baseURL = getSafeConfigValue(
				config,
				EOS_ENDPOINT_DICTIONARY[internalConfig.service],
			);
			return internalConfig;
		} catch (err) {
			return Promise.reject(err);
		}
	};
};

export default useServiceInterceptor;
